"use client";

import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

function Contact() {
  const sectionRef = useRef(null);
  const { t } = useTranslation("translation");
  // const [form, setForm] = useState({
  //   name: "",
  //   email: "",
  //   subject: "",
  //   message: "",
  // });

  useEffect(() => {
    if (window.location.hash === "#contact") {
      sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // const handleChange = (
  //   e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   const { name, value } = e.target;
  //   setForm((prev) => ({ ...prev, [name]: value }));
  // };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   console.log("Form submitted:", form);
  //   alert("Message sent!");
  //   setForm({ name: "", email: "", subject: "", message: "" });
  // };

  return (
    <section ref={sectionRef} id="contact" className="py-8 px-4">
      <h2 className="text-2xl font-bold mb-2 text-[var(--color-main)]">{t("contact.contact")}</h2>
      <h3 className="text-base text-[var(--color-subtext)]">
  {t("contact.text")}{" "}
  <span className="text-[var(--color-main)] underline">
    bassmayed@gmail.com
  </span>
</h3>

      {/* <div className="contact-container">
        <h2 className="contact-title">Contact Me</h2>

        <form onSubmit={handleSubmit} className="contact-form">
          <input
            id="name"
            name="name"
            type="text"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
            className="contact-input"
          />

          <input
            id="email"
            name="email"
            type="email"
            placeholder="Your Email"
            value={form.email}
            onChange={handleChange}
            required
            className="contact-input"
          />

          <input
            id="subject"
            name="subject"
            type="text"
            placeholder="Subject"
            value={form.subject}
            onChange={handleChange}
            required
            className="contact-input"
          />

          <textarea
            id="message"
            name="message"
            placeholder="Your Message"
            value={form.message}
            onChange={handleChange}
            required
            className="contact-textarea"
          />

          <button type="submit" className="contact-button">
            Send Message
          </button>
        </form>
      </div> */}
    </section>
  );
}

export default Contact;
